import numeral from 'numeral';

type InputValue = string | number | null;

// export const fNumber = (number: number | string, decimal: number = 2): string => {
//   if (typeof unfNumber(number) !== 'number') return '';

//   // Split the number into integer and decimal parts
//   const [integer, fraction] = number.toString().split('.');

//   // Add commas to the integer part
//   const formattedInteger = numeral(integer).format('0,0');

//   // Format the fraction part if needed
//   if (decimal !== undefined && fraction) {
//     const trimmedFraction = fraction.slice(0, decimal); // Limit to the specified decimal places

//     if (decimal === 0 || !trimmedFraction) {
//       return formattedInteger;
//     }

//     // Check if fraction is exactly '0', '00', or '000'
//     const hideFraction = ['0', '00', '000'].includes(trimmedFraction);

//     return hideFraction || decimal === 0
//       ? formattedInteger
//       : `${formattedInteger}.${trimmedFraction}`;
//   }

//   // If no decimal places specified or no fraction part exists, return as is
//   return fraction || fraction === '' ? `${formattedInteger}.${fraction}` : formattedInteger;
// };

export const unfNumber = (value: string | number): number =>
  typeof value === 'string' ? numeral(value).value() || 0 : value; // Convert formatted value to plain number

export const isFloat = (num: number) => Number(num) === num && !Number.isInteger(num);

export function fData(inputValue: InputValue) {
  if (!inputValue) return '';

  if (inputValue === 0) return '0 Bytes';

  const units = ['bytes', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

  const decimal = 2;

  const baseValue = 1024;

  const number = Number(inputValue);

  const index = Math.floor(Math.log(number) / Math.log(baseValue));

  const fm = `${parseFloat((number / baseValue ** index).toFixed(decimal))} ${units[index]}`;

  return fm;
}

export const fNumber = (
  number: number | string,
  decimal: number = 3,
  minDecimal: number = 0,
  isHideFraction: boolean = false
): string => {
  if (typeof unfNumber(number) !== 'number') return '';

  // Split the number into integer and decimal parts
  const [integer, fraction] = number.toString().split('.');

  // Add commas to the integer part
  const formattedInteger = numeral(integer).format('0,0');

  // Format the fraction part if needed
  if (typeof decimal === 'number') {
    let trimmedFraction = fraction ? fraction.slice(0, decimal) : ''; // Limit to the specified decimal places

    // เติมศูนย์ท้ายทศนิยมให้ครบ minDecimal
    if (trimmedFraction.length < minDecimal) {
      trimmedFraction = trimmedFraction.padEnd(minDecimal, '0');
    }

    // ถ้าไม่ต้องการทศนิยมหรือไม่มีทศนิยมเลย
    if (decimal === 0 || !trimmedFraction) {
      return formattedInteger;
    }

    // Check if fraction is exactly '0', '00', หรือ '000' ตามจำนวน decimal
    const hideFraction = isHideFraction ? trimmedFraction === '0'.repeat(decimal) : undefined;

    return hideFraction || decimal === 0
      ? formattedInteger
      : `${formattedInteger}.${trimmedFraction}`;
  }

  // If no decimal places specified or no fraction part exists, return as is
  return fraction || fraction === '' ? `${formattedInteger}.${fraction}` : formattedInteger;
};
